import React, { useState, useRef, RefObject } from "react";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import useOnClickOutside from "src/app/methods/useOnClickOutside";
import { ReactComponent as PlusWhite } from "src/images/plus-white.svg";
import QuickActionsMenu from "./QuickActionsMenu";

import "./QuickActions.scss";

interface QuickActionsProps {
  sidebarRef: RefObject<HTMLDivElement>;
}

export default function QuickActions({ sidebarRef }: QuickActionsProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const itemRef = useRef<HTMLLIElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  const rect = itemRef.current?.getBoundingClientRect();

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  useOnClickOutside(menuRef, () => setIsMenuOpen(false));

  return (
    <li
      ref={itemRef}
      className="quick-actions"
      onClick={toggleMenu}
      data-qa="quick-actions-sidebar-item"
    >
      <div className="quick-actions__icon-container quick-actions__icon">
        <PlusWhite />
      </div>
      <span className="sidebar__item-text text-h7-medium">
        <IDHFormattedMessage
          id="ws_quick_actions"
          defaultMessage="Quick Actions"
        />
      </span>
      {isMenuOpen && rect && (
        <QuickActionsMenu
          sidebarRef={sidebarRef}
          topPosition={rect.top}
          onClose={() => setIsMenuOpen(false)}
        />
      )}
    </li>
  );
}
